import React, { useEffect } from 'react';
import styles from './myDropDown.css';
import SwedishFlagIcon from '../../../assets/svg/swedishFlag.svg';
import UKFlagIcon from '../../../assets/svg/ukFlag.svg';
import { setLocalizationLangs } from '../../../data/localization/actions';
import moment from 'moment';
import 'moment/locale/sv';
import 'moment/locale/en-gb';
import { useSelector, useDispatch } from 'react-redux';

/**
 *
 * @type {React.NamedExoticComponent<object>}
 */
const MyDropDown = React.memo( () => {

    const { localization: { lang } } = useSelector( ( state ) => state );
    const dispatch = new useDispatch();
    const langSwich = localStorage.getItem( 'lang' ) ? localStorage.getItem( 'lang' ) : 'en';

    useEffect( () => {
        moment.defaultFormat = 'DD/MM/YYYY HH:mm';

        if ( langSwich === 'en' ) {
            moment.locale( 'en-gb' );
        } else {
            moment.locale( 'sv' );
        }
        dispatch( setLocalizationLangs( langSwich ) );
    }, [] );

    const setLanguage = () => {
        if ( lang === 'en' ) {
            dispatch( setLocalizationLangs( 'se' ) );
            localStorage.setItem( 'lang', 'se' );
            moment.locale( 'sv' );
        }
        if ( lang === 'se' ) {
            dispatch( setLocalizationLangs( 'en' ) );
            localStorage.setItem( 'lang', 'en' );
            moment.locale( 'en-gb' );
        }
    };

    const getIcon = () => {
        switch ( lang ) {
            case 'se': return ( <SwedishFlagIcon onClick={ setLanguage }/> );
            case 'en': return ( <UKFlagIcon onClick={ setLanguage }/> );
            default: return ( <UKFlagIcon onClick={ setLanguage }/> );
        }
    };

    return (
        <div className={ styles.wrapper }>
            { getIcon() }
        </div>
    );
} );


export default MyDropDown;